import React from 'react';
// Mui components
import { Box, Tooltip, Checkbox, Typography } from '@mui/material';
// CustomHooks
import { toCamelCaseFirstWord } from '../../../utils/Hooks/textFormatted';

function CardEspecialidades({ especialidad, especialidadSeleccionada, setEspecialidadSeleccionada }) {
    
    const handleClick = () => {
        setEspecialidadSeleccionada(prevState =>
            prevState.map(e =>
                e.codigoOsde === especialidad.codigoOsde
                    ? { ...e, solicitada: !e.solicitada }  // Cambia 'solicitada' al valor contrario
                    : e
            )
        );
    };

    const isChecked = especialidadSeleccionada.some(e => e.codigoOsde === especialidad.codigoOsde && e.solicitada === true);

    return (
        <Box
            onClick={especialidad?.interoperabilidad ? handleClick : undefined}
            sx={{
                display: 'flex', alignItems: 'center', border: '1px solid #ccc', borderRadius: 3, padding: 1, width: '70%', maxWidth: '530px',
                ...(isChecked && {
                    backgroundColor: '#E7E9F7',
                    borderColor: '#E7E9F7'
                }),
                '&:hover': {
                    backgroundColor: '#E7E9F7',
                    cursor: especialidad?.interoperabilidad ? 'pointer' : 'not-allowed',
                },
            }}
        >
            <Tooltip
                title="La especialidad no está habilitada"
                arrow
                placement="top"
                disableHoverListener={especialidad?.interoperabilidad} // si está habilitada, no muestra tooltip
            >
                <span>
                    <Checkbox
                        checked={isChecked}
                        disabled={!especialidad?.interoperabilidad}
                    />
                </span>
            </Tooltip>
            <Typography variant='bodyS'>
                {toCamelCaseFirstWord(especialidad.descripcion)}
            </Typography>
        </Box>
    );
}

export default CardEspecialidades;
